<script setup lang="ts">
import { ref, defineProps, defineEmits } from 'vue';

const { checked = false, property = '', disabled = false, contactId, title = '' } = defineProps<{
  contactId: Number
  checked: String
  property: String
  disabled?: String
  // O motivo da marca atual, mostrado ao passar o mouse: e' por que este numero esta como esta.
  // `string` minusculo, e nao `String`: vai para o atributo title do DOM, que quer a primitiva.
  title?: string
}>()

const readonly = ref(false)

const emits = defineEmits(['updateContact'])

const onUpdateContact = async () => {
  console.log('onUpdateContact')
  readonly.value = true
  await emits('updateContact')
  readonly.value = false
}

</script>

<template>
  <input type="checkbox" 
    :id="'contact_id_' + property + contactId"
    :checked="checked ? true : false"
    :disabled="disabled ? true : false"
    :title="title || undefined"
    @click="onUpdateContact"
    class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
</template>
